import { Fragment, useEffect, useState } from "react";
import { Button, Icon, Label } from "semantic-ui-react";

import { Appro } from "../../models";
import { DistributorService, HelperService } from "../../services";
import { DistributorApproForm, DistributorApproList, ErrorMessage, LoadingSpinner } from "../../components";
import { FeedbackMessage } from "../../constants";

export function DistributorProvisionningPage() {

    const [loadingData, setLoadingData] = useState(true)

    const [errorLoadingData, setErrorLoadingData] = useState(false)
    const [errorOpeningTill, setErrorOpeningTill] = useState(false)
    const [errorFetchingTillStatus, setErrorFetchingTillStatus] = useState(false)


    const [openingTill, setOpeningTill] = useState(false)
    const [isTillOpened, setIsTillOpened] = useState<boolean>(false)
    const [checkingTillStatus, setCheckingTillStatus] = useState(true)

    const [userRole, setUserRole] = useState<string>('')
    const [createModalVisible, setCreateModalVisible] = useState(false)
    const [approsList, setApprosList] = useState<Appro[]>([])
    const [approsListCopy, setApprosListCopy] = useState<Appro[]>([])

    const addToList = (appro: Appro) => setApprosList([appro, ...approsList])

    const hideForm = () => setCreateModalVisible(false)


    useEffect(() => {

        setUserRole(HelperService.getRoleFromToken())

            DistributorService.getRequestForApproList()
                .then(data => {
                    setApprosList(data)
                    setApprosListCopy(data)
                    setLoadingData(false)
                })
                .catch(_ => setErrorLoadingData(true))
                .finally(() => setLoadingData(false))

            
            DistributorService.getMyTillStatus()
            .then(data => setIsTillOpened(data))
            .catch(err => setErrorFetchingTillStatus(true))
            .finally(() => setCheckingTillStatus(false))


    }, [])


    const handleOpenTill = async () => {

        setOpeningTill(true)

        try {
            await DistributorService.openMyTill()
            setIsTillOpened(true)
        }
        catch (e) {
            setErrorOpeningTill(true)
        }
        finally {
            setOpeningTill(false)
        }
    }

    return <div>

        {checkingTillStatus && <LoadingSpinner />}
        {errorLoadingData && <ErrorMessage errorText={FeedbackMessage.APPRO_FETCH_ERROR} />}
        {errorOpeningTill && <ErrorMessage errorText={FeedbackMessage.TILL_OPENING_ERROR} />}
        {errorFetchingTillStatus && <ErrorMessage errorText={FeedbackMessage.TILL_STATUS_FETCH_ERROR} />}

        {!checkingTillStatus && isTillOpened && 
        
            <Fragment>
                {
                    !loadingData && !errorLoadingData ?
                        <Fragment>
                            <div className='headerRow'>
                                <h2>Demandes d'appros reçus:  <Label circular color="orange" size="big">{approsList.length}</Label></h2>
                            </div>

                            <div style={
                                {
                                    height: createModalVisible ? '350px' : '0px',
                                    overflow: 'hidden',
                                    transition: 'height 0.5s ease-in-out',
                                    marginBottom: createModalVisible ? '30px' : '0px'
                                }}>
                                <DistributorApproForm addToList={addToList} hideForm={hideForm} />
                            </div>

                            <DistributorApproList
                                userRole={userRole}
                                approsList={approsList}
                                setApprosList={setApprosList}
                                approsListCopy={approsListCopy}
                                setApprosListCopy={setApprosListCopy}
                            />
                        </Fragment> :
                        <LoadingSpinner />
                }
            </Fragment>
        }


        {
            !checkingTillStatus && !isTillOpened &&
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
                <h2>Votre caisse est fermée</h2>
                <p className="size-17">Vous devez ouvrir votre caisse pour pouvoir recevoir de l'argent</p>
                <br />
                <br />
                <br />
                <Button size='huge' secondary onClick={handleOpenTill} loading={openingTill}>
                    <Icon name='unlock alternate' />
                    Ouvrir ma caisse <Icon name='arrow alternate circle right outline' />
                </Button>
            </div>
        }
    </div>
}